import './productPreviewThumbnails.scss';

import {
    ProductImage,
    ProductMedia,
    ProductVideo,
} from '../../../classes/ProductMedia';
import React, { useMemo, useState } from 'react';

import { GatsbyImage } from 'gatsby-plugin-image';
import classNames from 'classnames';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

const MAX_SHOW_THUMBNAIL = 6;

type ProductPreviewThumbnailsProps = {
    productMedias: ProductMedia[];
    selectedImage: number;
    setSelectedImage: (index: number) => void;
    product: Queries.ProductJsonTemplateFragment;
};

export default function ProductPreviewThumbnails(
    props: ProductPreviewThumbnailsProps
) {
    const { productMedias, selectedImage, setSelectedImage, product } = props;
    const { currentLocale } = usePageLocalization();

    const [offsetShow, setOffsetShow] = useState(0);

    const { t } = useTranslation('templatePages');

    const max_show =
        productMedias.length <= MAX_SHOW_THUMBNAIL
            ? productMedias.length
            : MAX_SHOW_THUMBNAIL + offsetShow - 1;

    const imagesNode = useMemo(() => {
        const newImagesNode: React.ReactNode[] = [];
        productMedias.forEach((media, forEachIndex) => {
            newImagesNode.push(
                <div
                    className={classNames('thumbnail', {
                        'selected:': forEachIndex === selectedImage,
                        hide: !(
                            forEachIndex >= offsetShow &&
                            forEachIndex < max_show
                        ),
                    })}
                    key={`image-single-${forEachIndex}`}
                    onClick={() => {
                        setSelectedImage(forEachIndex);
                    }}
                >
                    {media instanceof ProductImage && (
                        <GatsbyImage
                            key={forEachIndex}
                            image={
                                media.image?.childImageSharp?.gatsbyImageData!
                            }
                            alt={`${product.title?.[currentLocale]} | ${
                                product.category?.includes('Wood Stoves')
                                    ? t('stove')
                                    : t('insert')
                            } | Century Heating `}
                        />
                    )}

                    {media instanceof ProductVideo && (
                        <img
                            src={media.thumbnailUrl}
                            key={forEachIndex}
                            alt=''
                            className='image video'
                            title='youtube'
                        />
                    )}
                </div>
            );
        });
        return newImagesNode;
    }, [offsetShow, productMedias]);

    const maxOffset = (): boolean =>
        offsetShow + max_show > productMedias.length;
    const minOffset = (): boolean => offsetShow <= 0;

    return (
        <div
            className={classNames('product-thumbnails', {
                'is-show-nav': productMedias.length > MAX_SHOW_THUMBNAIL,
            })}
        >
            {imagesNode}
            <div className='thumnail-prev thumbnail-nav'>
                <span
                    className={classNames('iconfont iconfont-prev', {
                        'not-clickable': minOffset(),
                    })}
                    onClick={() => {
                        if (!minOffset()) {
                            setOffsetShow(offsetShow - 1);
                        }
                    }}
                />
            </div>
            <div className='thumbnail-next thumbnail-nav'>
                <span
                    className={classNames('iconfont iconfont-next', {
                        'not-clickable': maxOffset(),
                    })}
                    onClick={() => {
                        if (!maxOffset()) {
                            setOffsetShow(offsetShow + 1);
                        }
                    }}
                />
            </div>
        </div>
    );
}
